import type { LocalDate } from '@js-joda/core';
import type { Universe } from '@thinkalpha/platform-ws-client/contracts/universe.js';

export type UserSetFilingsUniverseAction = {
    type: 'userSetFilingsUniverse';
    tabId: string;
    universe: Universe | string | null;
};

export const userSetFilingsUniverse = (
    tabId: string,
    universeId: Universe | string | null,
): UserSetFilingsUniverseAction => ({
    type: 'userSetFilingsUniverse',
    universe: universeId,
    tabId,
});

export interface UserSetFilingsSymbolFilter {
    type: 'userSetFilingsSymbolFilter';
    symbolFilter: string | null;
    tabId: string;
}

export const userSetFilingsSymbolFilter = (tabId: string, symbolFilter: string | null): UserSetFilingsSymbolFilter => ({
    type: 'userSetFilingsSymbolFilter',
    symbolFilter,
    tabId,
});

export interface UserSetFilingsFilingTypes {
    type: 'userSetFilingsFilingTypes';
    filingTypes: string[];
    tabId: string;
}

export const userSetFilingsFilingTypes = (tabId: string, filingTypes: string[]): UserSetFilingsFilingTypes => ({
    type: 'userSetFilingsFilingTypes',
    filingTypes,
    tabId,
});

export interface UserSetFilingsGoToDate {
    type: 'userSetFilingsGoToDate';
    tabId: string;
    date: LocalDate | null;
}

export const userSetFilingsGoToDate = (tabId: string, date: LocalDate | null): UserSetFilingsGoToDate => ({
    type: 'userSetFilingsGoToDate',
    date,
    tabId,
});

export type UpdateFillingsSymbolFilterAction = { type: 'updateFillingsSymbolFilter'; tabId: string; symbol: string };
export const updateFillingsSymbolFilter = (tabId: string, symbol: string): UpdateFillingsSymbolFilterAction => ({
    tabId,
    symbol,
    type: 'updateFillingsSymbolFilter',
});

export interface UserSetFilingsFastIdeas {
    type: 'userSetFilingsFastIdeas';
    fastIdeas: string[];
    tabId: string;
}

export const userSetFilingsFastIdeas = (tabId: string, fastIdeas: string[]): UserSetFilingsFastIdeas => ({
    type: 'userSetFilingsFastIdeas',
    fastIdeas,
    tabId,
});

export interface UserSetFilingsSymbolRetention {
    type: 'userSetFilingsSymbolRetention';
    symbolRetention: string;
    tabId: string;
}

export const userSetFilingsSymbolRetention = (
    tabId: string,
    symbolRetention: string,
): UserSetFilingsSymbolRetention => ({
    type: 'userSetFilingsSymbolRetention',
    symbolRetention,
    tabId,
});

export type FilingsWidgetActions =
    | UserSetFilingsUniverseAction
    | UserSetFilingsSymbolFilter
    | UserSetFilingsFilingTypes
    | UserSetFilingsGoToDate
    | UpdateFillingsSymbolFilterAction
    | UserSetFilingsFastIdeas
    | UserSetFilingsSymbolRetention;
